import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, PageHeader, Spinner, Badge, StatCard, Select } from "@/components/ui";
import { ShieldCheck, Clock, CheckCircle2, XCircle } from "lucide-react";

export default function UtilizationManagement() {
  const [items, setItems] = useState(null);
  const [status, setStatus] = useState("");

  const load = () => api.get("/um-requests", { params: { status } }).then((r) => setItems(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const all = items || [];
  const counts = {
    pending: all.filter((u) => u.status.includes("Pending")).length,
    approved: all.filter((u) => u.status === "Approved").length,
    denied: all.filter((u) => u.status === "Denied").length,
  };
  const avgTat = (() => {
    const withTat = all.filter((u) => u.turnaround_hours);
    if (!withTat.length) return "—";
    return Math.round(withTat.reduce((s, u) => s + u.turnaround_hours, 0) / withTat.length) + "h";
  })();

  return (
    <div className="vc-fade-up">
      <PageHeader title="Utilization Management" subtitle="Prior authorization, concurrent, and retrospective review with SLA turnaround tracking." />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Pending Review" value={counts.pending} icon={Clock} tone="amber" />
        <StatCard label="Approved" value={counts.approved} icon={CheckCircle2} tone="brand" />
        <StatCard label="Denied" value={counts.denied} icon={XCircle} tone="red" />
        <StatCard label="Avg Turnaround" value={avgTat} sub="SLA target: 72h" icon={ShieldCheck} tone="blue" />
      </div>

      <Card className="p-4 my-4">
        <Select value={status} onChange={(e) => setStatus(e.target.value)} data-testid="um-filter">
          <option value="">All Statuses</option><option>Pending</option><option>Approved</option><option>Denied</option><option>Pending Info</option>
        </Select>
      </Card>

      {items === null ? <Spinner /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
                <th className="px-4 py-3 font-semibold">Auth #</th><th className="px-4 py-3 font-semibold">Member</th>
                <th className="px-4 py-3 font-semibold">Service</th><th className="px-4 py-3 font-semibold">Type</th>
                <th className="px-4 py-3 font-semibold">Units</th><th className="px-4 py-3 font-semibold">TAT</th>
                <th className="px-4 py-3 font-semibold">Reviewer</th><th className="px-4 py-3 font-semibold">Status</th></tr></thead>
              <tbody className="divide-y divide-border">
                {items.map((u) => (
                  <tr key={u.id} className="hover:bg-muted transition-colors">
                    <td className="px-4 py-3 font-mono text-xs">{u.auth_number}</td>
                    <td className="px-4 py-3 text-muted-foreground">{u.member_name}</td>
                    <td className="px-4 py-3 font-medium">{u.service}</td>
                    <td className="px-4 py-3 text-muted-foreground">{u.request_type}</td>
                    <td className="px-4 py-3 font-mono">{u.units_requested}</td>
                    <td className="px-4 py-3 font-mono text-muted-foreground">{u.turnaround_hours ? `${u.turnaround_hours}h` : "—"}</td>
                    <td className="px-4 py-3 text-muted-foreground">{u.reviewer}</td>
                    <td className="px-4 py-3"><Badge tone={u.status.includes("Pending") ? "Pending" : u.status}>{u.status}</Badge></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
